interface MailToProps {
    email: string;
    subject: string;
    body: string;
}

export function mailToHandler({ email, subject, body }: MailToProps) {
    return () => {
        const url = `mailto:${email}?subject=${encodeURIComponent(
            subject,
        )}&body=${encodeURIComponent(body)}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };
}
